import { type Answer, type FileAnswer } from '../services/additionalInfo/model';

export const CHARACTER_LIMIT = 255;

export const ERROR_ID = {
  TEXT: 'inputError',
  CHECKBOX: 'checkboxError',
  RADIO: 'radioButtonError',
  FILE: 'fileUploadError',
  CONSENT: 'missingConsentError',
};

export const VALIDATORS = {
  TEXT: (answer: string[]): string => {
    const textAnswer = answer[0] || '';
    if (textAnswer.trim().length === 0) {
      return 'components.additionalInfo.fieldCantBeEmpty';
    }
    if (textAnswer.length > CHARACTER_LIMIT) {
      return 'components.additionalInfo.tooManyCharacters';
    }
    return '';
  },
  CHECKBOX: (answer: string[]): string => {
    return answer.length > 0
      ? ''
      : 'components.additionalInfo.choiceFieldCantBeEmpty';
  },
  RADIO: (answer: string[]): string => {
    return answer.length > 0
      ? ''
      : 'components.additionalInfo.radioFieldCantBeEmpty';
  },
  FILE: (answer: FileAnswer[]): string => {
    return answer.length > 0
      ? ''
      : 'components.additionalInfo.fileFieldCantBeEmpty';
  },
  CONSENT: (hasConsent: boolean): string => {
    return hasConsent
      ? ''
      : 'components.additionalInfo.missingFileUploadConsent';
  },
};

export const hasMissingConsent = (
  answers: Answer[],
  hasFileUploadConsent: boolean,
): boolean => {
  const fileAnswers = answers.filter((answer) => isFileAnswer(answer));
  return fileAnswers.length > 0 && !hasFileUploadConsent;
};

export const hasMissingAnswer = (answers: Answer[]): boolean => {
  const completedAnswers = answers
    .map((nextAnswer: Answer) => nextAnswer.answer.join('').trim())
    .filter(Boolean);
  return completedAnswers.length !== answers.length;
};

export const hasExceededCharactersLength = (answers: Answer[]): boolean => {
  return answers.some(
    (nextAnswer: Answer) =>
      nextAnswer.questionType === 'TEXT' &&
      nextAnswer.answer.join('').length > CHARACTER_LIMIT,
  );
};

export const getAnswersPayload = (
  answers: Answer[],
  hasFileUploadConsent: boolean,
): Answer[] => {
  return answers.map((nextAnswer: Answer) => {
    return {
      questionId: nextAnswer.questionId,
      answer:
        nextAnswer.questionType === 'TEXT'
          ? [nextAnswer.answer.join('').trim()]
          : nextAnswer.answer,
      questionType: nextAnswer.questionType,
      ...(nextAnswer.questionType === 'FILE' &&
        hasFileUploadConsent && { hasConsent: true }),
    };
  });
};

export const isFileAnswer = (answer: Answer): boolean => {
  return answer.questionType === 'FILE';
};
